<template lang="pug">
    .markdown-editor
        .actions
            v-btn(@click="addBoldText()" :disabled="showPreview" icon small)
                v-icon format_bold
            v-btn(@click="addLink($event)" :disabled="showPreview" icon small)
                v-icon link
            v-divider(vertical)
            v-btn(
                :title="$vuetify.t('$vuetify.markdown.preview')" icon small
                @click="togglePreview()"
                :disabled="!value.length"
            )
                v-icon {{ !showPreview ? 'visibility' : 'visibility_off' }}
        v-textarea(
            v-show="!showPreview"
            id="editor"
            :label="$vuetify.t('$vuetify.pages.News.text')"
            :value="value"
            @input="onTextChange($event)"
            :rows="1"
            :error-messages="errorMessage"
            color="dark"
            :class="{'resize': !value}"
            clearable
            auto-grow
            counter
            maxlength="1400"
        )
        .preview-content(v-if="showPreview")
            span(v-html="markdown(value)")
</template>

<script>
import { markdown } from '@/utils/helpers'

export default {
    props: {
        value: {
            type: String,
            default: null
        },
        errorMessage: {
            type: String,
            default: null
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        showPreview: false
    }),
    methods: {
        markdown,
        onTextChange(value) {
            this.$emit('input', value || '')
        },
        addLink() {
            const editor = document.getElementById('editor')
            const caretPosition = editor.selectionStart

            if (caretPosition >= 0) {
                const textPlaceholder = this.$vuetify.t('$vuetify.markdown.text')
                const linkPlaceholder = this.$vuetify.t('$vuetify.markdown.link')

                const newTextValue = this.value.insert(`[${textPlaceholder}](${linkPlaceholder})`, caretPosition)
                this.$emit('input', newTextValue || '')
            }
        },
        addBoldText() {
            const selection = window.getSelection()
            const selectedText = selection.toString()

            if (selectedText && selectedText.length) {
                const boldRegex = /\*\*|__/g
                const isBold = boldRegex.test(selectedText)

                // If selected string doesn't have special bold markdown
                // we should add it, or remove otherwise.
                const replaceString = !isBold
                    ? `**${selectedText}**`
                    : selectedText.replace(boldRegex, '')

                const newTextValue = this.value.replace(selectedText, replaceString)
                this.$emit('input', newTextValue || '')
            }
        },
        togglePreview() {
            this.showPreview = !this.showPreview
        }
    }
}
</script>

<style lang="scss" scoped>
    $border: 1px lightgray solid;

    .actions {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        border-top: $border;
        border-bottom: $border;
        padding-left: 10px;

        .v-btn:last-of-type {
            margin-right: unset;
        }
    }

    .preview-content {
        padding: 10px;
        white-space: pre-line;
        border-bottom: $border;
        user-select: none;
    }

    ::v-deep .v-textarea {
        &.resize {
            textarea {
                height: 32px!important;
            }
        }
    }
</style>
